import { FormControl } from "@angular/forms";
import _ from "lodash";
declare module "@angular/forms" {
  interface FormControl {
    pushValue(value: any): void;
    setValueAsArray(value: any): void;
  }
}

FormControl.prototype.pushValue = function (this: FormControl, value: any) {
  if (!Array.isArray(this.value)) {
    throw Error("This is not an array");
  }
  const oldValues = _.cloneDeep(this.value);
  const newValues = [...oldValues, value];
  this.setValue(newValues);
};

FormControl.prototype.setValueAsArray = function (this: FormControl, value: any) {
  if (Array.isArray(value)) {
    this.setValue(_.cloneDeep(value));
  } else {
    this.setValue([_.cloneDeep(value)]);
  }
};
